import React from 'react';
import { Icon, Tag } from '../../common/commonModels';
import TileComponent from '../../common/components/TileComponent';
import { FlexBox, JustifyContent, FlexDirection } from '../../utils/css-classes';

const defaultTitle = 'Unsorted';

interface Props {
  shipmentCount: number;
  iconClassName: Icon;
  tags: Tag[];
}

// tslint:disable-next-line:function-name
export default function UnsortedShipmentsTileComponent({
  shipmentCount,
  iconClassName,
  tags,
}: Props) {
  const tagsPart = tags.map(tag => (
    <div key={`${tag.key}-${tag.value}`} className={`${FlexBox.FLEX} ${JustifyContent.SPACE_BETWEEN}`}>
      <div>{tag.key[0].toUpperCase() + tag.key.slice(1)}</div>
      <div className="pl-2 "><strong>{tag.value}</strong></div>
    </div>
  ));

  const noTagsPart = (
    <div className={`${FlexBox.FLEX} ${JustifyContent.CENTER}`}>
      {defaultTitle}
    </div>
  );

  return (
    <div className={`${FlexBox.FLEX} ${FlexDirection.COLUMN} mr-4 mb-4`}>
      <TileComponent
        title=""
        iconClassName={iconClassName}
        topRightLabelText={`${shipmentCount}`}
        paddingClass="pt-4"
      />
      <div className="mt-2 ml-4 small">
        {tags.length > 1 ? tagsPart : noTagsPart}
      </div>
    </div>
  );
}
